/**
 * Responsible for handling category menu
 * @module modules/toggleContent
 */

import $ from 'jquery';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'categoryMenu';
export const CLICK_EVENT = 'click';

export const DEFAULTS = {
  speed: 500,
};

const closeAllCategoryMenu = () => {
  $("[category-body-lock='true']").categoryMenu('toggle');
};

const setMenuHeight = ($el) => {
  if ($el.length) {
    $el.show();
    const menuHeight = $(window).height() - $el.offset().top;
    $el.hide();
    $el.css({ maxHeight: menuHeight });
  }
};
/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 */
const itemClickHandler = ({ currentTarget }, $el) => {
  const $scrollEl = $($el.attr('data-toggle-select-this'));
  if ($el.hasClass('is-active')) {
    $el.attr('category-body-lock', '');
    enableBodyScroll($scrollEl[0]);
    $scrollEl.slideUp();
    $scrollEl.removeClass('is-active');
    $el.removeClass('is-active');
    $scrollEl.off('scroll.catmenu');
    $('html, body').stop();
  } else {
    $el.attr('category-body-lock', 'true');
    disableBodyScroll($scrollEl[0]);
    $scrollEl.slideDown(400, () => {
      $scrollEl.css('overflow', '');
    });
    $scrollEl.addClass('is-active');
    $el.addClass('is-active');
    $scrollEl.on('scroll.catmenu', () => {
      $('html, body').animate({ scrollTop: -1 }, 0);
    });
  }
};
/**
 * Applies any sort of event handlers for the toggleContent.
 * @private
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
const applyEventHandlers = ($el, opts = {}) => {
  $el
    .on(CLICK_EVENT, evt => itemClickHandler(evt, $el, opts));
};
/**
 * Initializes an categoryMenu
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @see DEFAULTS
 */
export default function categoryMenu(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setMenuHeight($($el.attr('data-toggle-select-this')));
  applyEventHandlers($el, opts);
  return {
    toggle: () => itemClickHandler(opts, $el),
  };
}
$.categoryMenu = (options) => {
  $('<div/>').categoryMenu(options);
};
$.categoryMenu.close = () => {
  closeAllCategoryMenu();
};
// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, categoryMenu);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/category-menu.js